export const CARD_MEDIA_SM = '40px';
export const CARD_MEDIA_MD = '116px';
export const CARD_MEDIA_LG = '253px';
export const DYNAMIC_IMAGE_SIZE = 1000;
